import {
  avatarSizeVariants,
  defaultAvatarStyles,
  teamAvatarStyles,
} from "./avatar.css";
import { AvatarProps } from "./types";

const Avatar = ({ children, code, size = "medium" }: AvatarProps) => {
  const baseClass =
    code && code in teamAvatarStyles
      ? teamAvatarStyles[code as keyof typeof teamAvatarStyles]
      : defaultAvatarStyles;

  const classNames = `${baseClass} ${avatarSizeVariants[size]}`;

  return <div className={classNames}>{children}</div>;
};

export default Avatar;
